// extracted by mini-css-extract-plugin
export default {"container":"ContentLoader_container__3o4xr","container__spinner":"ContentLoader_container__spinner__wdfSc","spin":"ContentLoader_spin__EWotl"};